import React, {useContext} from "react";
import {useState, useCallback} from "react";
import {userServices} from "../../services";
import {FullDate} from "../tools/delivery-tools";
import { Directions } from "../tools/cross-dock-tools";
import {notification, Popconfirm} from "antd";
import ModalSelectCarrierLegalEntity from "../modals/select-carrier-legal-entity";
import RedirectModal from "../modals/redirect-modal";
import ModalRefuseCrossDock from "../modals/refuse-cross-dock";
import {AppContext} from "../../contexts/app-context";
import i18n from "../../i18n";
import { crossDockService } from "../../services/cross-dock.services";
import { CROSS_DOCK_DRAFT, CROSS_DOCK_IN_CALCULATION } from "../../helpers/cross_dock_status.helper";

export default function CrossDockItemContent({
                                              crossDock,
                                              setNeedUpdate,
                                              setStopListUpdate,
                                            }) {

  let user = userServices.getUser();
  const isUserStaff = !!user.info.isStaff;
  const appContext = useContext(AppContext);

  let btnSendCalculate = null;
  let btnRefuse = null;

  const [showSelectCarrierLegalEntityModal, setSelectCarrierLegalEntityModal] = useState(false);
  const [redirectText, setRedirectText] = useState('');
  const [showRedirectModal, setShowRedirectModal] = useState(false);
  const [redirectRoute, setRedirectRoute] = useState('');
  const [showAllItems, setShowAllItems] = useState(false);
  const [showDirections, setShowDirections] = useState(false);
  const [showRefuseModal, setShowRefuseModal] = useState(false);

  const onClickSendCalculate = (e) => {
    e.preventDefault();

    crossDockService
      .sendCalculate(crossDock.id)
      .then((response) => {
        if(response.status === "error" && response.errorType) {
          const user = userServices.getUser();
          if (response.errorType === "need_shipper_contract") {
              setSelectCarrierLegalEntityModal(true);
          } else if (response.errorType === "need_check_contract_state") {
              setRedirectRoute("/consignor/orders-to-shipper-company");
              setRedirectText(response.message);
              setShowRedirectModal(true);
          }
        } else {
          notification.success({
            message: i18n.t('Отправка заявки'),
            description: response.message
          });

          appContext.setIsNeedUpdateUnloadingList(true);
        }
      }).catch((error) => {

      notification.error({
        message: i18n.t('Отправка заявки'),
        description: error
      });

      appContext.setIsNeedUpdateUnloadingList(true);
    })

  }

  const onConfirmRefuse = () => {
    crossDockService
      .refuse(crossDock.id)
      .then((response) => {
        if(response.status === "success") {
          notification.success({
            message: i18n.t('Отмена заявки'),
            description: response.message
          });

          appContext.setIsNeedUpdateUnloadingList(true);
        } else {
          notification.error({
            message: i18n.t('Отмена заявки'),
            description: response.message
          });
        }
      }).catch((error) => {

        notification.error({
          message: i18n.t('Отмена заявки'),
          description: error
        });

      })
  }

  const onRefuseWithReason = (reason) => {
    return crossDockService
      .refuse(crossDock.id, reason)
      .then((response) => {
        if(response.status === "success") {
          notification.success({
            message: i18n.t('Отмена заявки'),
            description: response.message
          });

          appContext.setIsNeedUpdateUnloadingList(true);
        } else {
          notification.error({
            message: i18n.t('Отмена заявки'),
            description: response.message
          });
        }
      }).catch((error) => {

        notification.error({
          message: i18n.t('Отмена заявки'),
          description: error
        });

      })
  }

  if (crossDock != null && crossDock.statusAlias == CROSS_DOCK_DRAFT) {
    btnSendCalculate = (
      <>
        <Popconfirm
          title={i18n.t('Вы уверены?')}
          onConfirm={onClickSendCalculate}
          okText={i18n.t('Да')}
          cancelText={i18n.t('Нет')}
        >
          <a className="action-button typical-btn-blue">
            {i18n.t('Отправить')}
          </a>
        </Popconfirm>
      </>
    );

    btnRefuse = (
      <>
        <Popconfirm
          title={i18n.t('Вы уверены?')}
          onConfirm={onConfirmRefuse}
          okText={i18n.t('Да')}
          cancelText={i18n.t('Нет')}
        >
          <a className="action-button typical-btn-red">
            {i18n.t('Отменить')}
          </a>
        </Popconfirm>
      </>
    );
  }

  if (crossDock != null && crossDock.statusAlias == CROSS_DOCK_IN_CALCULATION) {
    btnRefuse = (
      <a className="action-button typical-btn-red" onClick={() => setShowRefuseModal(true)}>
        {i18n.t('Отменить')}
      </a>
    );
  }

  return (
    <>
    <div className={`item-view   non-bot-bord clrfx`}>
      <div className="col s1">
        <div className="top-view">
          <div className="col-pos-top">
            <div className="informer-item">
              <div className="h-informer">{i18n.t('Номер заявки')}</div>
              <div className="b-informer">{crossDock.id}</div>
            </div>
          </div>
          <div className="col-pos-top">
            <div className="informer-item">
              <div className="h-informer">{i18n.t('Отправитель')}</div>
              <div className="b-informer">{crossDock.legalEntityName || '-'}</div>
            </div>
          </div>
          <div className="col-pos-top">
            <div className="informer-item">
              <div className="h-informer">{i18n.t('Поставщик кросс-докинга')}</div>
              <div className="b-informer">{crossDock.shipperCompanyName || '-'}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="col s2">
        <div className="top-view">
          <div className="col-pos-top">
            <div className="informer-item">
              <div className="h-informer">{i18n.t('Статус заявки')}</div>
              <div className="b-informer">{crossDock.statusTitle}</div>
            </div>
          </div>
          <div className="col-pos-top">
            <div className="informer-item">
              <div className="h-informer">{i18n.t('Дата поставки в РЦ')}</div>
              <div className="b-informer">{crossDock.dateShipment ? <FullDate date={crossDock.dateShipment}/> : '-'}</div>
            </div>
          </div>
          <div className="col-pos-top">
            <div className="informer-item">
              <div className="h-informer">{i18n.t('Распределительный центр')}</div>
              <div className="b-informer">
                <span 
                  style={{cursor: 'pointer'}}
                  onClick={() => setShowDirections(!showDirections)}
                >
                  {crossDock.distributionCenterName || '-'}
                </span>
                {showDirections && (
                  <div style={{
                    marginTop: '16px',
                    paddingLeft: '20px',
                    textAlign: 'left',
                  }}>
                    <Directions images={crossDock.distributionCenterImages}/>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col s3">
        <div className="top-view">
          {crossDock.items && crossDock.items.length > 0 ? (
            <>
              {crossDock.items.slice(0, showAllItems ? crossDock.items.length : 1).map((item, index) => (
                <div key={item.id || index} className="cross-dock-item" style={{
                  marginBottom: '12px',
                  padding: '10px',
                  border: '1px solid #e8e8e8',
                  borderRadius: '6px',
                  backgroundColor: '#fafafa'
                }}>
                  <div style={{fontWeight: '500', marginBottom: '4px', color: '#333'}}>
                    {item.storeName || '-'}
                  </div>
                  <div style={{marginBottom: '6px', color: '#666'}}>
                    {item.name || '-'}
                  </div>
                  <div style={{display: 'flex', marginBottom: '4px'}}>
                    <div style={{width: '50%', fontSize: '13px'}}>
                      <span style={{color: '#999'}}>{i18n.t('Объём')}:</span> {item.volume != null ? `${item.volume} м³` : '-'}
                    </div>
                    <div style={{width: '50%', fontSize: '13px'}}>
                      <span style={{color: '#999'}}>{i18n.t('Вес')}:</span> {item.weight != null ? `${item.weight} кг` : '-'}
                    </div>
                  </div>
                  <div style={{display: 'flex', marginBottom: '4px'}}>
                    <div style={{width: '50%', fontSize: '13px'}}>
                      <span style={{color: '#999'}}>{i18n.t('Цена')}:</span> {item.price != null ? `${item.price} ₽` : '-'}
                    </div>
                    <div style={{width: '50%', fontSize: '13px'}}>
                      <span style={{color: '#999'}}>{i18n.t('Цена доставки')}:</span> {item.priceDelivery != null ? `${item.priceDelivery} ₽` : '-'}
                    </div>
                  </div>

                  {item.deliveryInfo.id && 
                  <div style={{fontWeight: '500', marginBottom: '4px', color: '#333'}}>
                    Рейс №{item.deliveryInfo.number} {item.deliveryInfo.status}
                  </div>}
                </div>
              ))}
              {crossDock.items.length > 1 && !showAllItems && (
                <a 
                  onClick={() => setShowAllItems(true)}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    fontSize: '13px'
                  }}
                >
                  {i18n.t('Ещё')} {crossDock.items.length - 1} ↓
                </a>
              )}
              {crossDock.items.length > 1 && showAllItems && (
                <a 
                  onClick={() => setShowAllItems(false)}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    fontSize: '13px'
                  }}
                >
                  {i18n.t('Свернуть')} ↑
                </a>
              )}
            </>
          ) : (
            <div className="col-pos-top">
              <div className="informer-item">
                <div className="h-informer">{i18n.t('Позиции')}</div>
                <div className="b-informer">{i18n.t('Нет данных')}</div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="col s4">
        <div className="top-view">
          {crossDock.priceDelivery != 0 &&
          <>
            <div className="col-pos-top">
              <div className="informer-item">
                <div className="h-informer">{i18n.t('Цена доставки')}</div>
                <div className="b-informer">{crossDock.priceDelivery != null ? `${crossDock.priceDelivery} ₽` : '-'}</div>
              </div>
            </div>
            <div className="col-pos-top">
              <div className="informer-item">
                <div className="h-informer">{i18n.t('Статус оплаты')}</div>
                <div className="b-informer">{crossDock.isPaid ? 'Оплата подтверждена' : 'Ожидает оплаты'}</div>
              </div>
            </div>
          </>}
           {crossDock.documents && crossDock.documents.invoice && (
             <div className="col-pos-top">
               <a 
                 className="action-button typical-btn-blue"
                 href={crossDock.documents.invoice}
                 target="_blank"
                 rel="noopener noreferrer"
                 style={{textDecoration: 'none', marginBottom: '8px'}}
               >
                 {i18n.t('Скачать счет')}
               </a>
             </div>
           )}
           {crossDock.documents && crossDock.documents.waybill && (
             <div className="col-pos-top">
               <a 
                 className="action-button typical-btn-blue"
                 href={crossDock.documents.waybill}
                 target="_blank"
                 rel="noopener noreferrer"
                 style={{textDecoration: 'none', marginBottom: '8px'}}
               >
                 {i18n.t('Скачать накладную')}
               </a>
             </div>
           )}
           {crossDock.documents && crossDock.documents.registry && (
             <div className="col-pos-top">
               <a 
                 className="action-button typical-btn-blue"
                 href={crossDock.documents.registry}
                 target="_blank"
                 rel="noopener noreferrer"
                 style={{textDecoration: 'none'}}
               >
                 {i18n.t('Скачать реестр')}
               </a>
             </div>
           )}
          {btnSendCalculate}
          {btnRefuse}
        </div>
      </div>
    </div>
    <ModalSelectCarrierLegalEntity
        isShow={showSelectCarrierLegalEntityModal}
        setIsShow={setSelectCarrierLegalEntityModal}
        delivery={{"CustomerCompanyId": crossDock.shipperCompanyId}}
        setNeedUpdateDeliveryList={setNeedUpdate}
        setStopListUpdate={setStopListUpdate}
        initLegalEntity={crossDock.legalEntityId}
        allowContractTypes={['cross_dock']}
    />
    <RedirectModal
        isShow={showRedirectModal}
        setIsShow={setShowRedirectModal}
        route={redirectRoute}
        text={redirectText}
        setNeedUpdateDeliveryList={setNeedUpdate}
    />
    <ModalRefuseCrossDock
        isShow={showRefuseModal}
        setIsShow={setShowRefuseModal}
        crossDockId={crossDock.id}
        onRefuse={onRefuseWithReason}
    />
    </>
  );
}
